import { TemplatePage } from '../TemplatePage';

export const ManageModelHomeTemplates = () => {
  return <TemplatePage type="ModelHome" title="Model Home" />;
};
